export const UPLOAD_PROGRESS_EVENT = 'upload:progress';
export const UPLOAD_COMPLETE_EVENT = 'upload:complete';
export const MAX_FILE_SIZE = process.env.MAX_FILE_SIZE
    ? parseInt(process.env.MAX_FILE_SIZE)
    : 1024 * 1024 * 10;
export const API_HOST = process.env.API_HOST || 'http://localhost:3000';
export const SOCKET_HOST = process.env.SOCKET_HOST || 'http://localhost:3000';
export const MEDIA_HOST = process.env.MEDIA_HOST || 'http://localhost:3000';
export const DEFAULT_ACCEPT = {
    'image/*': ['.jpg', '.jpeg', '.png', '.gif'],
    'video/*': ['.mp4', '.mov']
};
export const TYPE_MAP = {
    image: ['jpg', 'jpeg', 'gif', 'png'],
    media: ['pdf', 'jpg', 'jpeg', 'gif', 'png', 'bmp', 'csv', 'xls', 'doc', 'docx', 'zip'],
    import: ['csv', 'xls', 'xlsx', 'xml'],
    drawings: ['pdf'],
    video: ['mp4', 'mov']
};
export const MIME_MAP = {
    'image/jpeg': 'jpg',
    'image/gif': 'gif',
    'image/png': 'png',
    'video/mpeg': 'mp4',
    'application/xml': 'xml',
    'application/zip': 'zip',
    'application/pdf': 'pdf',
    'application/msword': 'doc',
    'text/csv': 'csv'
};
export const MIME_TYPE_MAP = {
    jpg: 'image/jpeg',
    jpeg: 'image/jpeg',
    gif: 'image/gif',
    png: 'image/png',
    mp4: 'video/mpeg',
    xml: 'application/xml',
    zip: 'application/zip',
    pdf: 'application/pdf',
    doc: 'application/msword',
    csv: 'text/csv'
};
